!function(){var e,n;e=document.getElementById("zoomImageTrigger"),n=ui.modal("#zoomContent",{$trigger:e,open:!1}),e.addEventListener("click",function(){n.open()})}();
//# sourceMappingURL=photoViewer.js.map